import { TYPES } from "../actions";

const initialState = {
  emails: [],
  totalCount: 0,
  currentEmail: null,
  loading: false
};

export const tkt1EmailReducer = (state = initialState, action) => {
  switch (action.type) {

    case TYPES.ACTION_GET_TKT1_EMAILS_SUCCESS:
      return { 
        ...state, 
        emails: action.payload.data.data, 
        totalCount: action.payload.data.pagination?.total_count > -1 ? action.payload.data.pagination.total_count : state.totalCount,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_EMAILS_FAIL:
      return { 
        ...state, 
        emails: [],
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_EMAIL_BY_ID_SUCCESS:
      return { 
        ...state, 
        currentEmail: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_EMAIL_BY_ID_FAIL:
      return { 
        ...state, 
        currentEmail: null,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_EMAIL_SUCCESS:
      return { 
        ...state, 
        emails: [action.payload.data, ...state.emails],
        totalCount: state.totalCount + 1,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_EMAIL_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_EMAIL_SUCCESS:
      return { 
        ...state, 
        emails: state.emails.map(email => 
          email._id === action.payload.data._id ? action.payload.data : email
        ),
        currentEmail: state.currentEmail && state.currentEmail._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentEmail,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_EMAIL_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_EMAIL_SUCCESS:
      return { 
        ...state, 
        emails: state.emails.filter(email => email._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentEmail: state.currentEmail && state.currentEmail._id === action.payload.id 
          ? null 
          : state.currentEmail,
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_EMAIL_FAIL:
      return { 
        ...state, 
        loading: false
      };
      
    default:
      return state;
  }
};